const miracleBalmSetBuilder = (() => {
  /* ────────────────────────────────────────────────────────────────────
     Vanilla shims for the webpack imports the extracted module references.
     Keeping the same identifier names means the rest of the extracted
     module (which was compiled against webpack output) runs unmodified.
     ──────────────────────────────────────────────────────────────────── */

  // uuid v4 shim — used to group bundle items on cart.
  const uuid__WEBPACK_IMPORTED_MODULE_1__ = {
    v4: function () {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        var v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }
  };

  // cartModel shim — re-fetches /cart.js and dispatches a "cart:refresh" event
  // so cart drawers / headers update after a set is added.
  const _cart_cartModel__WEBPACK_IMPORTED_MODULE_0__ = {
    default: {
      fetch: function (cb) {
        window.fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
            if (window.CartDrawer && typeof window.CartDrawer.renderContents === 'function') {
              try { window.CartDrawer.renderContents({ sections: null, items: cart.items }); } catch (e) {}
            }
            if (typeof cb === 'function') cb();
          })
          .catch(function () { if (typeof cb === 'function') cb(); });
      }
    }
  };

  // Swiper shim — if the real Swiper is globally loaded use it, else use a
  // minimal vanilla fallback that implements just the API the modal uses
  // (appendSlide / removeAllSlides / slideToLoop / destroy + slideChange).
  function MiniSwiper(el, opts) {
    this.el = typeof el === 'string' ? document.querySelector(el) : el;
    this.opts = opts || {};
    this.wrapper = this.el ? this.el.querySelector('.swiper-wrapper') : null;
    this.realIndex = 0;
  }
  MiniSwiper.prototype.removeAllSlides = function () {
    if (this.wrapper) this.wrapper.innerHTML = '';
  };
  MiniSwiper.prototype.appendSlide = function (html) {
    if (!this.wrapper) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var node = tmp.firstElementChild;
    if (node) this.wrapper.appendChild(node);
  };
  MiniSwiper.prototype.slideToLoop = function (i /*, speed */) {
    if (!this.wrapper) return;
    this.realIndex = i;
    var slides = this.wrapper.children;
    for (var k = 0; k < slides.length; k++) {
      slides[k].style.display = k === i ? '' : 'none';
    }
    if (this.opts.on && typeof this.opts.on.slideChange === 'function') {
      this.opts.on.slideChange.call(this);
    }
  };
  MiniSwiper.prototype.destroy = function () {
    if (this.wrapper) this.wrapper.innerHTML = '';
  };
  var SwiperCtor = (typeof window !== 'undefined' && window.Swiper) ? window.Swiper : MiniSwiper;
  const swiper__WEBPACK_IMPORTED_MODULE_2__ = { default: SwiperCtor };

  // product-media shim — swaps the main PDP gallery (thumbnails + slides)
  // when a variant / tier changes. This mirrors what the inline URL-param
  // handler in sections/product-hero-new.liquid already does.
  const _productMedia_product_media__WEBPACK_IMPORTED_MODULE_4__ = {
    default: {
      changeMedia: function (_form, media) {
        if (!media || !media.length) return;
        var fixW = function (u, w) {
          return typeof u === 'string' ? u.replace(/(\?v=[\w\d]+)&width=\d+\b/g, '$1&width=' + w) : u;
        };
        var slidesHtml = media.map(function (item, idx) {
          var eager = idx === 0 ? 'fetchpriority="high" loading="eager"' : 'loading="lazy"';
          if (item.type === 'image') {
            return '<div class="product__media-slide swiper-slide js-productMediaSlide"><div class="aspect-1-1"><img src="' + fixW(item.src, 1500) + '" width="500" height="500" class="aspect-child" ' + eager + '></div></div>';
          }
          return '<div class="product__media-slide swiper-slide js-productMediaSlide"><div class="aspect-1-1"><video class="aspect-child" width="500" muted loop playsinline preload="none" disablepictureinpicture disableremoteplayback><source data-src="' + fixW(item.src, 1500) + '" type="video/' + item.extension + '"></video></div></div>';
        }).join('');
        var thumbsHtml = media.map(function (item) {
          if (item.type === 'image') {
            return '<img src="' + fixW(item.src, 1500) + '" width="500" height="500" class="secondary-aspect-child" loading="lazy">';
          }
          var poster = item.thumb || item.poster || '';
          return '<video class="secondary-aspect-child" muted loop playsinline preload="none" disablepictureinpicture disableremoteplayback' + (poster ? ' poster="' + poster + '"' : '') + '><source data-src="' + fixW(item.src, 1500) + '" type="video/' + item.extension + '"></video>';
        }).join('');
        // Main gallery (scope to the PDP container so we don't touch modal swiper)
        var mediaRoot = document.querySelector('.js-productMedia');
        if (mediaRoot) {
          var wrapper = mediaRoot.querySelector('.swiper-wrapper');
          if (wrapper) {
            wrapper.innerHTML = slidesHtml;
            wrapper.removeAttribute('data-phn-active-variant');
          }
        }
        // Desktop thumbnails — exclude modal thumbnails (`.js-mbModalThumbs`)
        document.querySelectorAll('.phn-media-thumbs .product-secondary-images, .scrollable-product-secondary-images:not(.mb-upsell-modal__thumbs-wrap) > .product-secondary-images')
          .forEach(function (el) { if (!el.classList.contains('js-mbModalThumbs')) el.innerHTML = thumbsHtml; });
        // Mobile thumbnails
        var secMobile = document.querySelector('.product-secondary-images-mobile');
        if (secMobile) secMobile.innerHTML = thumbsHtml;
        document.dispatchEvent(new CustomEvent('phn:gallery-updated'));
      }
    }
  };

  /* ── Config & Selectors ── */
  const S = {
    ROOT_MAIN: '.js-mbSetBuilder',
    ROOT_MODAL: '.js-mbUpsellModal',
    DATA: '.js-mbProductData',
    FULL_DATA: '.js-mbMiniProductData',
    CARD: '.js-mbShadeCard',
    RINGS: '.js-mbRings',
    ATC: '.js-mbAtc',
    ATC_PRICE: '.js-mbAtcPrice',
    ATC_COMPARE: '.js-mbAtcCompare',
    TIER_INPUT: 'input[name="mb-tier"]',
    TIER_PRICE: '.mb-set-builder__tier-price',
    TIER_SAVE: '.mb-set-builder__tier-save',
    TAB: '.js-mbTab',
    LIST: '.js-mbShadeList',
    SCROLL_HINT: '.js-mbScrollHint',
    // Actions (for delegation)
    ACT_ADD: '.js-mbShadeAdd',
    ACT_PLUS: '.js-mbShadePlus',
    ACT_MINUS: '.js-mbShadeMinus',
    ACT_REMOVE_RING: '.js-mbRingRemove',
    ACT_CLOSE: '.js-mbUpsellClose',
    ACT_DISMISS: '.js-mbUpsellDismiss'
  };

  const STICKY_MINI_TITLE = '.js-mbStickyMiniTitle';
  const STICKY_MINI_TITLE_SET = '.js-mbStickyMiniTitleSet';
  const STICKY_ATC_SLOT = '.js-mbStickyAtcSlot';

  let productData = null;
  let fullVariants = null;
  /** Mini product variants (custom.carousel_media) — use for modal gallery so it matches Unified PDP */
  let miniFullVariants = null;
  let modalSwiper = null;
  let currencyObserver = null;
  /** Set when upsell modal opens (3 or 6); cleared on close — drives strict shade cap + ATC in modal */
  let modalUpsellTargetQty = null;
  let upsellScrollLockY = 0;
  let upsellScrollLocked = false;

  // State containers
  const instances = {
    main: {
      root: null,
      selections: {},
      tierQty: 1,
      tierPrice: 2000,
      total: 0,
      isModal: false,
      /** Set of 1 (mini view only): allow ladder 1 → 2 → Set of 3 → Set of 6 without disabling adds */
      dynamicFlow: false,
      /** True only after main Set-of-3 → Set-of-6 auto-upgrade (4th shade); enables downgrade when removing back to ≤3 */
      sixFromThreeUpgrade: false
    },
    modal: { root: null, selections: {}, tierQty: 3, tierPrice: 5700, total: 0, isModal: true, dynamicFlow: false }
  };

  /* ── Init ── */
  function init() {
    // 1. Parse Data
    const elData = document.querySelector(S.DATA);
    if (!elData) return;
    try {
      productData = JSON.parse(elData.textContent);
      [1, 3, 6].forEach(tier => preloadSetMedia(tier));
      const elMini = document.querySelector(S.FULL_DATA);
      const elStandard = document.querySelector('.js-mbStandardView .js-productData');
      if (elMini) {
        miniFullVariants = JSON.parse(elMini.textContent).variants;
        fullVariants = miniFullVariants;
        preloadMiniVariantMedia();
      } else if (elStandard) {
        fullVariants = JSON.parse(elStandard.textContent).variants;
      }
    } catch (e) { console.error('MB Builder: Data Error', e); }

    // 2. Setup Instances
    instances.main.root = document.querySelector(S.ROOT_MAIN);
    instances.modal.root = document.querySelector(S.ROOT_MODAL);

    // Move the upsell modal to <body> so position:fixed cannot be trapped
    // by any ancestor (e.g. .js-mbMiniView toggling display:none, or any
    // container with transform/filter/contain creating a containing block).
    if (instances.modal.root && instances.modal.root.parentElement !== document.body) {
      document.body.appendChild(instances.modal.root);
    }

    if (instances.main.root) {
      // Detect ?size=mini (handles SPA navigation where inline script doesn't run)
      const wantsMini = new URLSearchParams(window.location.search).get('size') === 'mini';
      if (wantsMini) {
        const stdView = document.querySelector('.js-mbStandardView');
        const miniView = document.querySelector('.js-mbMiniView');
        if (stdView) stdView.style.display = 'none';
        if (miniView) miniView.style.display = '';
        updateHeroFlag(true);
        document.querySelectorAll('.js-mbSizeToggle').forEach(b => {
          const active = b.dataset.size === 'mini';
          b.classList.toggle('mb-size-toggle__btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        // Parity with the size-toggle click: landing on Mini preselects the Set of 3 ("Most Popular") tier
        const threeRadio = instances.main.root.querySelector(`${S.TIER_INPUT}[value="3"]`);
        if (threeRadio) threeRadio.checked = true;
      }

      bindEvents();
      bindSizeToggle();
      bindCurrencyListener();

      // Init Main State
      const checked = instances.main.root.querySelector(`${S.TIER_INPUT}:checked`);
      if (checked) updateTierState(instances.main, checked);

      // Initial Render
      render(instances.main);
      checkScrollHint(instances.main.root);
      applyActiveTabFilter(instances.main);

      // Apply currency formatting so tier prices show two decimals (e.g. 22.00) in all regions
      const currencyCode = document.body.getAttribute('data-currency') || window.Shopify?.currency?.active;
      if (currencyCode && productData?.tiersByCurrency?.[currencyCode]) applyCurrency(currencyCode);

      if (isMiniView()) {
        document.body.classList.add('state--mini-view');
        const form = document.querySelector('.js-productForm');
        if (form) form.dataset.mbMiniActive = '1';
        selectDefaultShade();

        const weightEl = document.querySelector('.product__description-weight');
        if (weightEl) weightEl.textContent = '(8.5 g / 0.3 oz)';

        // Gallery was hidden via .mini-gallery-pending to avoid flashing standard images; reveal now that mini media is injected
        const html = document.documentElement;
        html.classList.remove('mini-gallery-pending');
        html.classList.add('mini-gallery-ready');
      }
    }
  }

  function destroy() {
    document.removeEventListener('click', handleClick);
    document.removeEventListener('change', handleChange);
    document.removeEventListener('theme:currency:change', onCurrencyChange);
    document.removeEventListener('localization:change', onCurrencyChange);
    if (currencyObserver && currencyObserver.disconnect) currencyObserver.disconnect();
    if (modalSwiper) modalSwiper.destroy();
  }

  /* ── Multi-currency ── */
  /** Format price from cents without rounding — exact decimal from integer cents */
  function formatTierPrice(cents, symbol) {
    const c = Math.round(Number(cents));
    const d = Math.floor(c / 100);
    const r = c % 100;
    const centsStr = r < 10 ? '0' + r : String(r);
    const amount = d + '.' + centsStr;
    const withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return symbol + withCommas;
  }

  function applyCurrency(currencyCode) {
    if (!productData?.tiersByCurrency?.[currencyCode]) return;
    productData.tiers = productData.tiersByCurrency[currencyCode];
    productData.currencySymbol = productData.currencySymbols?.[currencyCode] || '$';
    const main = instances.main.root;
    if (!main) return;
    main.querySelectorAll(S.TIER_INPUT).forEach((input) => {
      const qty = Number(input.value);
      const tier = productData.tiers.find((t) => t.quantity === qty);
      if (!tier) return;
      input.dataset.totalPrice = tier.totalPrice;
      const label = input.closest('label');
      if (!label) return;
      const priceEl = label.querySelector(S.TIER_PRICE);
      const saveEl = label.querySelector(S.TIER_SAVE);
      if (priceEl) {
        priceEl.textContent = qty === 1
          ? formatTierPrice(tier.totalPrice, productData.currencySymbol)
          : formatTierPrice(tier.perEaCents, productData.currencySymbol) + '/ea';
      }
      if (saveEl && tier.saveCents != null) {
        saveEl.textContent = 'SAVE ' + formatTierPrice(tier.saveCents, productData.currencySymbol);
      }
    });
    const checked = main.querySelector(`${S.TIER_INPUT}:checked`);
    if (checked) {
      instances.main.tierPrice = Number(checked.dataset.totalPrice);
      const modalTier = productData.tiers.find((t) => t.quantity === instances.modal.tierQty);
      if (modalTier) instances.modal.tierPrice = modalTier.totalPrice;
    }
    render(instances.main);
    if (instances.modal.root) render(instances.modal);
  }

  function onCurrencyChange(e) {
    const code = e?.detail?.currency || document.body.getAttribute('data-currency') || window.Shopify?.currency?.active;
    if (code) applyCurrency(code);
  }

  function bindCurrencyListener() {
    document.addEventListener('theme:currency:change', onCurrencyChange);
    document.addEventListener('localization:change', onCurrencyChange);
    if (typeof MutationObserver !== 'undefined') {
      currencyObserver = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.type === 'attributes' && m.attributeName === 'data-currency') {
            const code = document.body.getAttribute('data-currency');
            if (code) applyCurrency(code);
          }
        });
      });
      if (document.body) currencyObserver.observe(document.body, { attributes: true, attributeFilter: ['data-currency'] });
    }
  }

  /* ── Event Delegation ── */
  function bindEvents() {
    document.addEventListener('click', handleClick);
    document.addEventListener('change', handleChange);
    
    // Scroll hints
    [instances.main.root, instances.modal.root].forEach(root => {
      const list = root?.querySelector(S.LIST);
      if (list) list.addEventListener('scroll', () => checkScrollHint(root));
    });

    // Re-check scroll hint when quiz injects Recommended tab (e.g. results page hero)
    document.addEventListener('mb-set-builder:check-scroll-hint', () => {
      if (instances.main.root) checkScrollHint(instances.main.root);
      if (instances.modal.root) checkScrollHint(instances.modal.root);
    });

    // Results page: re-apply order and recommended shades on every quiz:results-ready (e.g. when user re-submits quiz)
    document.addEventListener('quiz:results-ready', applyResultsPageRecommendedShades);
  }

  function handleClick(e) {
    // 1. Identify Context
    const modalRoot = e.target.closest(S.ROOT_MODAL);
    const mainRoot = e.target.closest(S.ROOT_MAIN);
    const inst = modalRoot ? instances.modal : (mainRoot ? instances.main : null);

    // 2. Routing Actions
    if (e.target.closest(S.ACT_ADD) || e.target.closest(S.ACT_PLUS)) {
      e.preventDefault();
      if (inst) {
        const variantId = e.target.closest('[data-variant-id]').dataset.variantId;
        modifyQty(inst, variantId, 1);
        // Select shade and update gallery image when adding
        const card = inst.root.querySelector(`${S.CARD}[data-variant-id="${variantId}"]`);
        if (card) handleCardClick(inst, card);
      }
    } 
    else if (e.target.closest(S.ACT_MINUS)) {
      e.preventDefault();
      if (inst) modifyQty(inst, e.target.closest('[data-variant-id]').dataset.variantId, -1);
    }
    else if (e.target.closest(S.ACT_REMOVE_RING)) {
      e.preventDefault();
      if (inst) modifyQty(inst, e.target.closest('[data-variant-id]').dataset.variantId, -1);
    }
    else if (e.target.closest(S.TAB)) {
      if (inst) handleTab(inst, e.target.closest(S.TAB));
    }
    else if (e.target.closest(S.ATC)) {
      e.preventDefault();
      if (inst) handleATC(inst, e.target.closest(S.ATC));
    }
    else if (e.target.closest(S.CARD)) {
      // Gallery Preview (ignore if clicking controls)
      if (!e.target.closest('.js-mbShadeActions')) {
        handleCardClick(inst, e.target.closest(S.CARD));
      }
    }
    else if (e.target.closest(S.ACT_CLOSE)) {
      e.preventDefault();
      closeModal();
    }
    else if (e.target.closest(S.ACT_DISMISS)) {
      e.preventDefault();
      handleDismiss();
    }
  }

  function handleChange(e) {
    if (e.target.matches(S.TIER_INPUT)) {
      updateTierState(instances.main, e.target);
    }
  }

  /* ── Core Logic ── */

  /* ── Dynamic Mode Helpers (Set of 1 flexible flow + Set-of-3 ladder) ── */

  /** Main-instance Set of 1 in mini view: ladder up 1→2→3→6 instead of capping at 1. */
  function isDynamicMode(inst) {
    return inst.dynamicFlow && !inst.isModal && isMiniView();
  }

  /** Upsell modal hard cap (3 or 6) set by openModal; null outside the modal. */
  function getModalUpsellCap(inst) {
    if (!inst.isModal || modalUpsellTargetQty == null) return null;
    return modalUpsellTargetQty;
  }

  function getDynamicRingCount(total) {
    if (total <= 1) return 1;
    if (total === 2) return 2;
    if (total === 3) return 3;
    return 6;
  }

  function getDynamicPrice(total) {
    const tiers = productData?.tiers || [];
    const t1 = tiers.find(t => t.quantity === 1);
    const t3 = tiers.find(t => t.quantity === 3);
    const t6 = tiers.find(t => t.quantity === 6);
    if (total <= 1) return t1?.totalPrice || 2000;
    if (total === 2) return (t1?.totalPrice || 2000) * 2;
    if (total === 3) return t3?.totalPrice || 5700;
    return t6?.totalPrice || 8700;
  }

  function getDynamicComparePrice(total) {
    const tiers = productData?.tiers || [];
    if (total === 2) {
      const t1 = tiers.find(t => t.quantity === 1);
      return t1?.comparePrice ? t1.comparePrice * 2 : 0;
    }
    if (total === 3) {
      const t3 = tiers.find(t => t.quantity === 3);
      return t3?.comparePrice || 0;
    }
    if (total >= 4) {
      const t6 = tiers.find(t => t.quantity === 6);
      return t6?.comparePrice || 0;
    }
    return 0;
  }

  /** ATC is enabled at 1, 2, 3, or 6 shades in dynamic flow (4–5 is the "select more" pre-Set-of-6 state). */
  function isDynamicAtcReady(total) {
    return (total >= 1 && total <= 3) || total === 6;
  }

  /** Mini dynamic flow: snap the active tier radio + price as shopper crosses 1/2 → 3 → 6 thresholds. */
  function autoSwitchTier(inst) {
    if (!isDynamicMode(inst)) return;

    let targetQty;
    if (inst.total <= 2) targetQty = 1;
    else if (inst.total === 3) targetQty = 3;
    else targetQty = 6;

    if (targetQty === inst.tierQty) return;

    const tier = productData?.tiers?.find(t => t.quantity === targetQty);
    if (!tier) return;

    inst.tierQty = targetQty;
    inst.tierPrice = tier.totalPrice;

    const radio = inst.root?.querySelector(`${S.TIER_INPUT}[value="${targetQty}"]`);
    if (radio) radio.checked = true;
  }

  /** Set of 3 main: allow more than three shades; once total exceeds three, move tier + UI to Set of 6. */
  function upgradeSetOfThreeToSix(inst) {
    if (inst.isModal || inst.tierQty !== 3 || inst.total <= 3) return;
    const tier = productData?.tiers?.find(t => t.quantity === 6);
    if (!tier) return;
    inst.tierQty = 6;
    inst.tierPrice = tier.totalPrice;
    if (!inst.isModal) inst.sixFromThreeUpgrade = true;
    const radio = inst.root?.querySelector(`${S.TIER_INPUT}[value="6"]`);
    if (radio) radio.checked = true;
  }

  /** Only after flexible Set-of-3→6 upgrade: removing back to ≤3 shades reverts tier to Set of 3. Explicit Set of 6 never auto-downgrades. */
  function downgradeSixToSetOfThree(inst) {
    if (inst.isModal || inst.tierQty !== 6) return;
    if (!inst.sixFromThreeUpgrade) return;
    if (inst.total < 1 || inst.total > 3) return;
    const tier = productData?.tiers?.find(t => t.quantity === 3);
    if (!tier) return;
    inst.tierQty = 3;
    inst.tierPrice = tier.totalPrice;
    inst.sixFromThreeUpgrade = false;
    const radio = inst.root?.querySelector(`${S.TIER_INPUT}[value="3"]`);
    if (radio) radio.checked = true;
  }

  function updateTierState(inst, input) {
    const newQty = Number(input.value);
    const currentTotal = inst.total;
    inst.tierQty = newQty;
    inst.tierPrice = Number(input.dataset.totalPrice);
    inst.dynamicFlow = (newQty === 1 && isMiniView());
    if (!inst.isModal) inst.sixFromThreeUpgrade = false;
    // Only reset when going down in quantity (e.g. 6→3, 6→1, 3→1). Preserve when going up (1→3, 1→6, 3→6).
    if (newQty < currentTotal) {
      inst.selections = {};
      inst.total = 0;
    }
    render(inst);
    if (isMiniView() && inst.total === 0) setGalleryToSetMedia(inst.tierQty);
  }

  function modifyQty(inst, id, delta) {
    const current = inst.selections[id] || 0;
    const next = current + delta;

    if (next < 0) return;
    // Cap: dynamic mini flow → 6; upsell modal → its strict target; main Set of 3 → 6 (auto-upgrades); else tierQty.
    const modalCap = getModalUpsellCap(inst);
    const cap = isDynamicMode(inst)
      ? 6
      : (modalCap != null ? modalCap : (inst.tierQty === 3 && !inst.isModal ? 6 : inst.tierQty));
    if (delta > 0 && inst.total >= cap) return;

    if (next === 0) delete inst.selections[id];
    else inst.selections[id] = next;

    inst.total += delta;
    autoSwitchTier(inst);
    upgradeSetOfThreeToSix(inst);
    downgradeSixToSetOfThree(inst);

    if (inst.total === 0 && !inst.isModal && isMiniView()) setGalleryToSetMedia(inst.tierQty);
    else if (delta > 0) { if (inst.isModal) updateModalGallery(id); else if (isMiniView()) updateMainGallery(id); }

    // UI Feedback (Status Label)
    // Only show "Added" on 0->1 transition
    // Only show "Removed" on 1->0 transition
    if (delta > 0 && current === 0) {
      showStatus(inst.root, id, 'Added');
    } else if (delta < 0 && next === 0) {
      showStatus(inst.root, id, 'Removed');
    }

    render(inst);
  }

  /* ── Rendering ── */

  function render(inst) {
    if (!inst.root) return;
    const dynamic = isDynamicMode(inst);
    const modalCap = getModalUpsellCap(inst);

    // 1. Update Rings
    const ringContainer = inst.root.querySelector(S.RINGS);
    if (ringContainer) {
      const filled = [];
      Object.entries(inst.selections).forEach(([id, qty]) => {
        const card = inst.root.querySelector(`${S.CARD}[data-variant-id="${id}"]`);
        const bg = card?.dataset.swatchBg;
        const isImg = card?.dataset.swatchIsImage === 'true';
        for (let i = 0; i < qty; i++) filled.push({ id, bg, isImg });
      });

      const ringCount = dynamic
        ? getDynamicRingCount(inst.total)
        : (modalCap != null ? modalCap : inst.tierQty);
      let html = '';
      for (let i = 0; i < ringCount; i++) {
        const item = filled[i];
        if (item) {
          const style = item.isImg ? `background-image: url(${item.bg}); background-size: cover;` : `background: ${item.bg};`;
          html += `<div class="mb-set-builder__ring mb-set-builder__ring--filled"><span class="mb-set-builder__ring-swatch" style="${style}"></span><button type="button" class="mb-set-builder__ring-remove js-mbRingRemove" data-variant-id="${item.id}" aria-label="Remove shade from set"><svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="white" stroke-width="1.5" stroke-linecap="round"><path d="M1 1l6 6M7 1L1 7"/></svg></button></div>`;
        } else {
          html += `<div class="mb-set-builder__ring mb-set-builder__ring--empty"><svg class="mb-set-builder__ring-icon" viewBox="0 0 13 13" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M1 6.5h11M6.5 1v11"/></svg></div>`;
        }
      }
      ringContainer.innerHTML = html;
    }

    // 2. Update Cards (upsell modal: strict cap from openModal target; main Set-of-3 allows up to 6; dynamic mini cap = 6)
    const effectiveCap = dynamic
      ? 6
      : (modalCap != null ? modalCap : (inst.tierQty === 3 && !inst.isModal ? 6 : inst.tierQty));
    const isFull = inst.total >= effectiveCap;
    inst.root.querySelectorAll(S.CARD).forEach(card => {
      const id = card.dataset.variantId;
      const qty = inst.selections[id] || 0;
      const isSel = qty > 0;

      card.classList.toggle('mb-set-builder__shade-card--selected', isSel);

      const countEl = card.querySelector('.js-mbShadeCount');
      if (countEl) countEl.textContent = qty;

      const addBtn = card.querySelector(S.ACT_ADD);
      const qtyWrap = card.querySelector('.js-mbShadeQty');

      // If we are showing status, don't toggle visibility yet (handled by timer)
      if (!card.dataset.statusActive) {
         if (addBtn) addBtn.classList.toggle('hidden', isSel || (isFull && !isSel));
         if (qtyWrap) qtyWrap.classList.toggle('hidden', !isSel);
      }

      if (addBtn) addBtn.disabled = isFull && !isSel;
      const plusBtn = card.querySelector(S.ACT_PLUS);
      if (plusBtn) plusBtn.disabled = isFull;
    });

    // Enable sticky atc body flag based on the *effective* ready state (matches ATC enable below)
    if (!inst.isModal) {
      let atcReady = dynamic ? isDynamicAtcReady(inst.total) : isFull;
      if (!dynamic && inst.tierQty === 3) {
        // Main Set-of-3: ATC is ready only at exactly 3 or after auto-upgrade to 6
        atcReady = inst.total === 3 || inst.total === 6;
      }
      document.body.classList.toggle('state--selected-shades-full', atcReady);
    }

    // 3. Update ATC
    const atc = inst.root.querySelector(S.ATC);
    if (atc) {
      const atcTextEl = atc.querySelector('.mb-set-builder__atc-text');

      if (dynamic) {
        const ready = isDynamicAtcReady(inst.total);
        atc.disabled = !ready;
        const price = getDynamicPrice(inst.total);
        atc.querySelector(S.ATC_PRICE).textContent = formatTierPrice(price, productData?.currencySymbol || '$');

        if (atcTextEl) {
          if (inst.total >= 4 && inst.total < 6) {
            atcTextEl.textContent = `Select ${6 - inst.total} more`;
          } else {
            atcTextEl.textContent = 'ADD TO CART';
          }
        }

        const cmp = atc.querySelector(S.ATC_COMPARE);
        if (cmp) {
          const comparePrice = getDynamicComparePrice(inst.total);
          const showCmp = comparePrice && comparePrice > price;
          cmp.style.display = showCmp ? '' : 'none';
          if (showCmp) cmp.textContent = formatTierPrice(comparePrice, productData?.currencySymbol || '$');
        }
      } else {
        let atcReady = isFull;
        if (modalCap != null) {
          atcReady = inst.total >= modalCap;
        } else if (inst.tierQty === 3 && !inst.isModal) {
          atcReady = inst.total === 3 || inst.total === 6;
        }
        atc.disabled = !atcReady;
        atc.querySelector(S.ATC_PRICE).textContent = formatTierPrice(inst.tierPrice, productData?.currencySymbol || '$');
        if (atcTextEl) atcTextEl.textContent = 'ADD TO CART';

        const cmp = atc.querySelector(S.ATC_COMPARE);
        if (cmp) {
          const tier = productData?.tiers?.find(t => t.quantity === inst.tierQty);
          const showCmp = tier?.comparePrice && tier.comparePrice > inst.tierPrice;
          cmp.style.display = showCmp ? '' : 'none';
          if (showCmp) cmp.textContent = formatTierPrice(tier.comparePrice, productData?.currencySymbol || '$');
        }
      }
    }

    // 4. Sync mini sticky bar (title + clone of ATC) when in mini view
    if (inst === instances.main && isMiniView()) syncStickyMiniAtc(inst);

    // 5. Upsell modal: Set-of-3 flow copy assumes "two more" minis; dynamic Set-of-1 can arrive with two already selected
    if (inst.isModal) updateUpsellModalSubheading();
  }

  function syncStickyMiniAtc(inst) {
    const slot = document.querySelector(STICKY_ATC_SLOT);
    const titleEl = document.querySelector(STICKY_MINI_TITLE);
    const atc = inst.root?.querySelector(S.ATC);
    if (!slot || !atc) return;

    const dynamic = isDynamicMode(inst);
    const effectiveTier = dynamic ? getDynamicRingCount(inst.total) : inst.tierQty;
    const setLabels = { 1: '', 2: '', 3: ' Set of 3', 6: ' Set of 6' };
    const setEl = document.querySelector(STICKY_MINI_TITLE_SET);
    if (setEl) setEl.textContent = setLabels[effectiveTier] != null ? setLabels[effectiveTier] : '';

    let clone = slot.querySelector('.js-mbAtc');
    if (!clone) {
      clone = atc.cloneNode(true);
      clone.classList.add('js-mbStickyAtcClone');
      clone.removeAttribute('id');
      clone.addEventListener('click', (e) => {
        e.preventDefault();
        atc.click();
      });
      slot.innerHTML = '';
      slot.appendChild(clone);
    }

    clone.disabled = atc.disabled;
    const clonePrice = clone.querySelector(S.ATC_PRICE);
    const origPrice = atc.querySelector(S.ATC_PRICE);
    if (clonePrice && origPrice) clonePrice.textContent = origPrice.textContent;
    const cloneCmp = clone.querySelector(S.ATC_COMPARE);
    const origCmp = atc.querySelector(S.ATC_COMPARE);
    if (cloneCmp && origCmp) {
      cloneCmp.style.display = origCmp.style.display;
      cloneCmp.textContent = origCmp.textContent;
    }
    const cloneTxt = clone.querySelector('.mb-set-builder__atc-text');
    const cloneLdr = clone.querySelector('.mb-set-builder__atc-loader');
    const origTxt = atc.querySelector('.mb-set-builder__atc-text');
    const origLdr = atc.querySelector('.mb-set-builder__atc-loader');
    if (cloneTxt && origTxt) {
      cloneTxt.style.display = origTxt.style.display;
      cloneTxt.textContent = origTxt.textContent;
    }
    if (cloneLdr && origLdr) cloneLdr.style.display = origLdr.style.display;
  }

  function showStatus(root, id, text) {
    const card = root.querySelector(`${S.CARD}[data-variant-id="${id}"]`);
    if (!card) return;
    const status = card.querySelector('.js-mbShadeStatus');
    const add = card.querySelector(S.ACT_ADD);
    const qty = card.querySelector('.js-mbShadeQty');
    
    if (!status) return;

    // Set flag to prevent render() from hiding status immediately
    card.dataset.statusActive = 'true';
    
    if (add) add.classList.add('hidden');
    if (qty) qty.classList.add('hidden');
    status.textContent = text;
    status.classList.remove('hidden');

    // Clear previous timer
    if (card.timer) clearTimeout(card.timer);

    card.timer = setTimeout(() => {
      delete card.dataset.statusActive;
      status.classList.add('hidden');
      render(root === instances.modal.root ? instances.modal : instances.main); // Re-render to show correct controls
    }, 200);
  }

  /* ── Results page: order shades by results (primary, alt1, alt2, then rest) in both Recommended and All tabs ── */

  function applyResultsPageRecommendedShades(e) {
    const data = e && e.detail;
    if (!data || !data.primaryShade || !data.primaryShade.name || !instances.main || !instances.main.root) return;

    // Run after product-hero has injected the Recommended tab
    setTimeout(() => {
      const root = instances.main.root;
      const list = root.querySelector(S.LIST);
      if (!list) return;

      const primaryName = String(data.primaryShade.name).trim();
      const alternates = (data.alternateShades || []).map(a => a && a.name && String(a.name).trim()).filter(Boolean);
      const firstThreeNames = [primaryName].concat(alternates.slice(0, 2));

      const allCards = Array.from(root.querySelectorAll(S.CARD));
      const nameToCard = new Map();
      allCards.forEach(card => {
        const t = (card.dataset.variantTitle || '').trim();
        if (t) nameToCard.set(t.toLowerCase(), card);
      });

      // Fill first 3 if we have fewer (e.g. no alternates)
      const orderedNamesForRec = [...firstThreeNames];
      while (orderedNamesForRec.length < 3) {
        const used = new Set(orderedNamesForRec.map(n => n.toLowerCase()));
        const next = allCards.find(c => !used.has((c.dataset.variantTitle || '').trim().toLowerCase()));
        if (!next) break;
        orderedNamesForRec.push((next.dataset.variantTitle || '').trim());
      }

      // Full order for list: primary, first alternate, second alternate, then all remaining cards (any order)
      const firstThreeCards = orderedNamesForRec.slice(0, 3).map(name =>
        nameToCard.get(name.toLowerCase()) || allCards.find(c => (c.dataset.variantTitle || '').trim().toLowerCase() === name.toLowerCase())
      ).filter(Boolean);
      const restCards = allCards.filter(c => !firstThreeCards.includes(c));
      const orderedCardsFull = firstThreeCards.concat(restCards);

      if (orderedCardsFull.length === 0) return;

      // Reorder the entire list so both Recommended and All tabs show results order
      orderedCardsFull.forEach(card => list.appendChild(card));

      // Recommended tab shows only first 3; All tab shows all (visibility handled by handleTab)
      const recTab = root.querySelector('.js-mbTab[data-category="recommended"]');
      if (recTab) recTab.dataset.shadeNames = orderedNamesForRec.slice(0, 3).join(',');

      // Results page: set category tag for every shade from shade catalog (so Recommended and All tabs show correct category)
      const catalog = typeof window.shadeCatalog === 'object' ? window.shadeCatalog : {};
      orderedCardsFull.forEach(card => {
        const tagEl = card.querySelector('.mb-set-builder__shade-tag');
        const name = (card.dataset.variantTitle || '').trim();
        const entry = name && catalog[name];
        if (tagEl && entry && entry.category) {
          tagEl.textContent = entry.category;
        }
      });

      // Re-apply current tab filter (show only 3 for Recommended, all for All)
      const activeTab = root.querySelector(S.TAB + '.active');
      if (activeTab) handleTab(instances.main, activeTab);

      // Same order in upsell modal (results page)
      const modalRoot = instances.modal?.root;
      if (modalRoot) {
        const modalList = modalRoot.querySelector(S.LIST);
        if (modalList) {
          const modalCards = Array.from(modalRoot.querySelectorAll(S.CARD));
          const modalNameToCard = new Map();
          modalCards.forEach(card => {
            const t = (card.dataset.variantTitle || '').trim();
            if (t) modalNameToCard.set(t.toLowerCase(), card);
          });
          const modalFirstThree = orderedNamesForRec.slice(0, 3).map(name =>
            modalNameToCard.get(name.toLowerCase()) || modalCards.find(c => (c.dataset.variantTitle || '').trim().toLowerCase() === name.toLowerCase())
          ).filter(Boolean);
          const modalRest = modalCards.filter(c => !modalFirstThree.includes(c));
          const modalOrderedFull = modalFirstThree.concat(modalRest);
          if (modalOrderedFull.length > 0) {
            modalOrderedFull.forEach(card => modalList.appendChild(card));
            const modalRecTab = modalRoot.querySelector('.js-mbTab[data-category="recommended"]');
            if (modalRecTab) modalRecTab.dataset.shadeNames = orderedNamesForRec.slice(0, 3).join(',');
            // Results page: set category tag for every shade in modal from shade catalog
            modalOrderedFull.forEach(card => {
              const tagEl = card.querySelector('.mb-set-builder__shade-tag');
              const name = (card.dataset.variantTitle || '').trim();
              const entry = name && catalog[name];
              if (tagEl && entry && entry.category) {
                tagEl.textContent = entry.category;
              }
            });
            const modalActiveTab = modalRoot.querySelector(S.TAB + '.active');
            if (modalActiveTab) handleTab(instances.modal, modalActiveTab);
          }
        }
      }

      requestAnimationFrame(() => {
        requestAnimationFrame(() => checkScrollHint(root));
      });
    }, 0);
  }

  /* ── Tabs & UI Helpers ── */

  function handleTab(inst, btn) {
    inst.root.querySelectorAll(S.TAB).forEach(t => t.classList.remove('active'));
    btn.classList.add('active');
    
    const cat = btn.dataset.category;
    const names = btn.dataset.shadeNames ? btn.dataset.shadeNames.split(',').map(s => s.trim().toLowerCase()) : [];
    
    inst.root.querySelectorAll(S.CARD).forEach(card => {
      const title = (card.dataset.variantTitle || '').toLowerCase();
      let show = (cat === 'all' || names.includes(title));
      // Shades hidden from the online store (custom.hide_from_online_store) may appear
      // ONLY in the quiz-driven "recommended" tab — never in All / category browse.
      if (show && cat !== 'recommended' && card.dataset.mbHiddenOnline === 'true') {
        show = false;
      }
      card.style.display = show ? '' : 'none';
    });

    checkScrollHint(inst.root);
  }

  function applyActiveTabFilter(inst) {
    if (!inst?.root) return;
    const activeTab = inst.root.querySelector(S.TAB + '.active');
    if (activeTab) handleTab(inst, activeTab);
  }

  function checkScrollHint(root) {
    const list = root?.querySelector(S.LIST);
    const hint = root?.querySelector(S.SCROLL_HINT);
    if (list && hint) {
      const hasOverflow = list.scrollHeight > list.clientHeight;
      const atBottom = list.scrollHeight - list.scrollTop - list.clientHeight < 10;
      const listReady = list.clientHeight > 0;
      // Only show hint when list is laid out and there is actually something to scroll
      hint.style.display = listReady && hasOverflow && !atBottom ? '' : 'none';
    }
  }

  function handleCardClick(inst, card) {
    const id = card.dataset.variantId;
    inst.root.querySelectorAll(S.CARD).forEach(c => c.classList.remove('mb-set-builder__shade-card--previewing'));
    card.classList.add('mb-set-builder__shade-card--previewing');

    if (inst.isModal) updateModalGallery(id);
    else updateMainGallery(id);
  }

  /* ── ATC & Upsell Logic ── */

  function handleATC(inst, btn, bypassUpsell = false) {
    // 1. Check Upsell Triggers
    const upsell = productData?.upsell;
    const dynamic = isDynamicMode(inst);

    if (!bypassUpsell && !inst.isModal) {
      if (dynamic) {
        if (inst.total <= 2 && upsell?.enabled && upsell.singleMini) return openModal(3, inst.selections);
        if (inst.total === 3 && upsell?.enabled && upsell.setOf3) return openModal(6, inst.selections);
      } else if (upsell?.enabled) {
        if (inst.tierQty === 1 && upsell.singleMini) return openModal(3, inst.selections);
        if (inst.tierQty === 3 && upsell.setOf3) return openModal(6, inst.selections);
      }
    }

    // 2. Add To Cart
    setLoading(btn, true);

    const effectiveQty = dynamic ? inst.total : inst.tierQty;
    let itemsPayload;

    if (effectiveQty <= 2) {
      // 1-2 shades: add as individual Minis (no bundle properties). Keep live cart metadata (_title, _image) when available.
      itemsPayload = Object.entries(inst.selections).map(([id, qty]) => {
        const card = inst.root.querySelector(`${S.CARD}[data-variant-id="${String(id)}"]`);
        const thumb = (card && card.dataset && card.dataset.cartThumb) || productData.productImage || '';
        const shadeTitle = (card && card.dataset && card.dataset.variantTitle) || '';
        const props = { _product: productData.productTitle };
        if (shadeTitle) props._title = shadeTitle;
        if (thumb) props._image = thumb;
        return { id: Number(id), quantity: qty, properties: props };
      });
    } else {
      // 3 or 6 shades: add as bundle
      const bundleTierQty = effectiveQty <= 3 ? 3 : 6;
      const bundleId = (0,uuid__WEBPACK_IMPORTED_MODULE_1__.v4)(); // Generate ONCE per set
      const tier = productData.tiers.find(t => t.quantity === bundleTierQty) || {};
      itemsPayload = Object.entries(inst.selections).map(([id, qty]) => ({
        id: Number(id),
        quantity: qty,
        properties: buildProps(id, inst, tier, bundleId, bundleTierQty)
      }));
    }

    var isSetBundle = effectiveQty > 2;
    var finishLoading = function () { setLoading(btn, false); };

    if (isSetBundle && window.JR && typeof window.JR.addSetThenOpen === 'function') {
      window.JR.addSetThenOpen(itemsPayload)
        .then(function () {
          if (inst.isModal) closeModal();
        })
        .catch(function () {})
        .finally(finishLoading);
      return;
    }

    // Use fetch to bypass intercepts (singles + fallback)
    window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: itemsPayload })
    })
    .then(function (r) {
      return r.json().then(function (body) {
        return { ok: r.ok, body: body };
      });
    })
    .then(function (res) {
      if (!res.ok) return;
      if (inst.isModal) closeModal();
      if (isSetBundle) {
        var refreshThenOpen = window.JR && window.JR.refreshCartThenOpen;
        if (typeof refreshThenOpen === 'function') {
          return refreshThenOpen();
        }
        var _jrRef = window.JR && window.JR.refreshAjaxCartSections;
        if (typeof _jrRef === 'function') _jrRef();
        window.dispatchEvent(new CustomEvent('cart-open'));
        return;
      }
      if (window.cartAddCallbacks) window.cartAddCallbacks.forEach(function (cb) { cb(); });
    })
    .catch(function () {})
    .finally(finishLoading);
  }

  function handleDismiss() {
    closeModal();
    // Logic: User rejected upsell. Add the *original* selection (from Main) to cart.
    const mainInst = instances.main;
    const btn = mainInst.root.querySelector(S.ATC);
    // Force add main instance items, bypass upsell check
    handleATC(mainInst, btn, true); 
  }

  function buildProps(variantId, inst, tier, bundleId, effectiveTierQty) {
    const tq = effectiveTierQty || inst.tierQty;
    const card = inst.root.querySelector(`${S.CARD}[data-variant-id="${String(variantId)}"]`);
    /* Property keys mirror live Mini Miracle Balm bundle lines (see cart.json):
       _bundle_id, _conditions (product_id @ tier quantity), _d, _shade_quantity,
       _title (shade name), _product, _product_id, _image (variant thumb 200px),
       _t, _finalSale. Analytics keys (__pdq*, _ig*) are injected on live PDP only. */
    const thumb =
      (card && card.dataset && card.dataset.cartThumb) ||
      productData.productImage ||
      '';
    return {
      _bundle_id: bundleId,
      _conditions: `${productData.productId}@${tq}`,
      _d: `miracle-balm-mini-set-${tq}`,
      _shade_quantity: tier.label || `SET OF ${tq}`,
      _title: (card && card.dataset && card.dataset.variantTitle) || '',
      _product: productData.productTitle,
      _product_id: Number(productData.productId),
      _image: thumb,
      _t: 'fix',
      _finalSale: 'true'
    };
  }

  function setLoading(btn, isLoading) {
    const apply = (b) => {
      if (!b) return;
      b.disabled = isLoading;
      b.classList.toggle('is-loading', isLoading);
      const txt = b.querySelector('.mb-set-builder__atc-text');
      const ldr = b.querySelector('.mb-set-builder__atc-loader');
      if (txt) txt.style.display = isLoading ? 'none' : '';
      if (ldr) ldr.style.display = isLoading ? '' : 'none';
    };
    apply(btn);
    // Sync loading state to sticky clone when main ATC is loading
    if (instances.main.root?.contains(btn) && btn.matches(S.ATC)) {
      const clone = document.querySelector(`${STICKY_ATC_SLOT} .js-mbStickyAtcClone`);
      apply(clone);
    }
  }

  /* ── Modal Specifics ── */

  /** Fixed-body scroll lock — avoids `overflow: hidden` on body which breaks sticky headers. */
  function clearUpsellScrollLockStyles() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.paddingRight = '';
  }

  function lockUpsellScroll() {
    if (upsellScrollLocked) return;
    upsellScrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${upsellScrollLockY}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    if (scrollbarWidth > 0) document.body.style.paddingRight = `${scrollbarWidth}px`;
    upsellScrollLocked = true;
  }

  function unlockUpsellScroll(onRestored) {
    const y = upsellScrollLocked ? upsellScrollLockY : 0;
    clearUpsellScrollLockStyles();
    upsellScrollLocked = false;
    upsellScrollLockY = 0;

    const finish = () => {
      if (typeof onRestored === 'function') onRestored();
      document.dispatchEvent(new CustomEvent('mb-upsell-scroll-unlocked', { detail: { scrollY: y } }));
    };

    if (y <= 0) {
      finish();
      return;
    }

    requestAnimationFrame(() => {
      window.scrollTo(0, y);
      requestAnimationFrame(finish);
    });
  }

  /** Set-of-3 upsell: theme subheading is written for "add two more"; when the shopper already has two minis, only one remains. */
  function updateUpsellModalSubheading() {
    const root = instances.modal.root;
    if (!root || modalUpsellTargetQty !== 3) return;
    const subEl = root.querySelector('.js-mbUpsellSubheading');
    if (!subEl) return;
    const base = productData?.upsell?.subheading || '';
    const needed = 3 - instances.modal.total;
    if (needed === 1) {
      subEl.textContent =
        'Add one more Mini to your cart and save, plus get a few more shades to try';
    } else if (needed === 2) {
      subEl.textContent =
        'Add two more Minis to your cart and save, plus get a few more shades to try';
    } else if (base) {
      subEl.textContent = base;
    }
  }

  function openModal(targetQty, preSelections) {
    const el = instances.modal.root;
    if (!el) return;

    modalUpsellTargetQty = targetQty;

    // Setup Modal State
    const tier = productData.tiers.find(t => t.quantity === targetQty);
    instances.modal.tierQty = targetQty;
    instances.modal.tierPrice = tier ? tier.totalPrice : (targetQty * 2000);
    instances.modal.selections = { ...preSelections }; // Clone
    instances.modal.total = Object.values(preSelections).reduce((a, b) => a + b, 0);

    // Update Text
    if (productData.upsell?.heading) el.querySelector('.js-mbUpsellHeading').textContent = productData.upsell.heading;
    if (productData.upsell?.subheading) el.querySelector('.js-mbUpsellSubheading').textContent = productData.upsell.subheading;
    updateUpsellModalSubheading();
    if (tier?.badge) el.querySelector('.js-mbUpsellBadge').textContent = tier.badge === 'Most Popular' ? 'Our set of 3 is the most popular' : tier.badge;

    // Dismiss Text (dynamic main can arrive with 1 or 2 minis selected)
    const mainTotal = instances.main.total;
    const prevQty = instances.main.tierQty;
    const dynamicMain = isDynamicMode(instances.main);
    let dismissText;
    if (dynamicMain && mainTotal <= 2) {
      dismissText = mainTotal === 1 ? 'No thanks, I only want one' : 'No thanks, just the two';
    } else if (prevQty === 1) {
      dismissText = 'No thanks, I only want one';
    } else {
      const prevLabel = productData.tiers.find(t => t.quantity === prevQty)?.label || 'current set';
      dismissText = `No thanks, just the ${prevLabel}`;
    }
    el.querySelector('.js-mbUpsellDismissText').textContent = dismissText;

    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('state--mb-upsell-open');
    document.body.classList.add('mb-upsell-open');
    lockUpsellScroll();

    render(instances.modal);
    applyActiveTabFilter(instances.modal);
    const list = el.querySelector(S.LIST);
    if (list) list.scrollTop = 0;

    // Open showing the heading; on mobile the shade list shrinks so ATC + dismiss stay in view
    const container = el.querySelector('.mb-upsell-modal__container');
    if (container) container.scrollTop = 0;

    // Init Gallery
    if (!modalSwiper) initModalGallery(el);
    const firstId = Object.keys(preSelections)[0] || el.querySelector(S.CARD)?.dataset.variantId;
    if (firstId) updateModalGallery(firstId);
  }

  function closeModal() {
    modalUpsellTargetQty = null;
    if (instances.modal.root) {
      instances.modal.root.setAttribute('aria-hidden', 'true');
    }
    document.body.classList.remove('mb-upsell-open');
    unlockUpsellScroll(() => {
      document.documentElement.classList.remove('state--mb-upsell-open');
    });
  }

  function initModalGallery(el) {
    modalSwiper = new swiper__WEBPACK_IMPORTED_MODULE_2__["default"](el.querySelector('.js-mbModalSwiper'), {
      loop: true, slidesPerView: 1,
      pagination: { el: '.js-mbModalPag', type: 'bullets', clickable: true },
      on: { slideChange: function() { syncThumbs(this.realIndex); } }
    });
    // Thumb clicks
    el.querySelectorAll('.js-mbModalThumbs .secondary-aspect-child').forEach((t, i) => {
      t.addEventListener('click', () => modalSwiper.slideToLoop(i));
    });
  }

  function syncThumbs(idx) {
    const thumbs = instances.modal.root.querySelectorAll('.js-mbModalThumbs .secondary-aspect-child');
    thumbs.forEach(t => t.classList.remove('secondary-images-active'));
    if (thumbs[idx]) thumbs[idx].classList.add('secondary-images-active');
  }

  function updateModalGallery(id) {
    // Use mini product data (same metafield as Unified PDP: custom.carousel_media)
    const variantsForGallery = miniFullVariants || fullVariants;
    if (!variantsForGallery || !modalSwiper) return;
    const v = variantsForGallery.find(v => String(v.id) === String(id));
    if (!v?.media) return;

    // Match Unified PDP gallery: src + srcset, same structure as product-media
    const buildMedia = (m, cls) => {
      if (m.type === 'video') {
        const poster = m.poster ? ` poster="${m.poster}"` : '';
        return `<video class="${cls}" muted loop playsinline${poster}><source src="${m.src}" type="video/${m.extension}"></video>`;
      }
      const srcset = m.srcset ? ` srcset="${m.srcset} 2x"` : '';
      return `<img src="${m.src}"${srcset} width="1500" height="1500" class="${cls}" loading="lazy">`;
    };

    // 1. Thumbs (same as PDP secondary images)
    instances.modal.root.querySelector('.js-mbModalThumbs').innerHTML =
      v.media.map(m => buildMedia(m, 'secondary-aspect-child')).join('');

    // 2. Swiper (same slide structure as PDP carousel)
    modalSwiper.removeAllSlides();
    v.media.forEach(m => {
      modalSwiper.appendSlide(`<div class="product__media-slide swiper-slide"><div class="aspect-1-1">${buildMedia(m, 'aspect-child')}</div></div>`);
    });

    // In loop mode use slideToLoop(0) so the main image shows the first slide, not the last
    modalSwiper.slideToLoop(0, 0);
    instances.modal.root.querySelectorAll('.js-mbModalThumbs .secondary-aspect-child').forEach((t, i) => {
      t.addEventListener('click', () => modalSwiper.slideToLoop(i));
    });
    syncThumbs(0);
  }

  /* ── Gallery & View Helpers ── */

  function updateMainGallery(id) {
    if (!fullVariants) return;
    const v = fullVariants.find(v => String(v.id) === String(id));
    const sectionWithGallery = document.querySelector('.js-productMedia')?.closest('.js-productSection');
    const form = sectionWithGallery?.querySelector('.js-productForm') || document.querySelector('.js-productForm');
    // Don't block on `form` — the shim doesn't need it, only the media payload.
    if (v?.media) _productMedia_product_media__WEBPACK_IMPORTED_MODULE_4__["default"].changeMedia(form, v.media);
  }

  function preloadSetMedia(tierQty) {
    if (!productData) return;
    const media = productData[tierQty === 1 ? 'setOneMedia' : tierQty === 3 ? 'setTwoMedia' : 'setThreeMedia'];
    (media || []).forEach(m => { if (m.type === 'image' && m.src) { const img = new Image(); img.src = m.src; } });
  }

  function preloadMiniVariantMedia() {
    if (!fullVariants || !fullVariants.length) return;
    fullVariants.forEach(v => {
      (v.media || []).forEach(m => {
        if (m.type === 'image' && m.src) {
          const img = new Image();
          img.src = m.src;
        }
      });
    });
  }

  function setGalleryToSetMedia(tierQty) {
    if (!isMiniView() || !productData) return;
    const sectionWithGallery = document.querySelector('.js-productMedia')?.closest('.js-productSection');
    const form = sectionWithGallery?.querySelector('.js-productForm') || document.querySelector('.js-productForm');
    const media = productData[tierQty === 1 ? 'setOneMedia' : tierQty === 3 ? 'setTwoMedia' : 'setThreeMedia'];
    if (media?.length) {
      _productMedia_product_media__WEBPACK_IMPORTED_MODULE_4__["default"].changeMedia(form, media);
      instances.main.root?.querySelectorAll(S.CARD).forEach(c => c.classList.remove('mb-set-builder__shade-card--previewing'));
    }
  }

  function isMiniView() {
    const mv = document.querySelector('.js-mbMiniView');
    return mv && mv.style.display !== 'none';
  }

  // Swap the hero media flag between the standard product's flag and the mini
  // product's flag. Each product owns its own flag tags, so the mini view must
  // never inherit the standard product's flag (and vice versa).
  function updateHeroFlag(isMini) {
    const flag = document.querySelector('.js-phMediaFlag');
    if (!flag) return;
    const text = isMini ? (flag.dataset.miniFlag || '') : (flag.dataset.stdFlag || '');
    if (text) {
      flag.textContent = text;
      flag.style.display = '';
    } else {
      flag.style.display = 'none';
    }
  }

  function selectDefaultShade() {
    setGalleryToSetMedia(instances.main.tierQty);
  }

  function bindSizeToggle() {
    document.querySelectorAll('.js-mbSizeToggle').forEach(btn => {
      btn.addEventListener('click', (e) => {
        const isMini = e.currentTarget.dataset.size === 'mini';
        document.querySelectorAll('.js-mbSizeToggle').forEach(b => {
          const active = b === e.currentTarget;
          b.classList.toggle('mb-size-toggle__btn--active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        
        document.querySelector('.js-mbStandardView').style.display = isMini ? 'none' : '';
        document.querySelector('.js-mbMiniView').style.display = isMini ? '' : 'none';
        updateHeroFlag(isMini);
        const form = document.querySelector('.js-productForm');
        if (form) form.dataset.mbMiniActive = isMini ? '1' : '';

        document.body.classList.toggle('state--mini-view', isMini);

        history.replaceState(null, '', isMini ? '/products/miracle-balm?size=mini' : '/products/miracle-balm');
        const weightEl = document.querySelector('.product__description-weight');
        if (weightEl) {
          weightEl.textContent = isMini ? '(8.5 g / 0.3 oz)' : '(50.0 g / 1.75 oz)';
        }

        // Selecting Mini preselects the Set of 3 ("Most Popular") tier.
        if (isMini) {
          const threeRadio = instances.main.root?.querySelector(`${S.TIER_INPUT}[value="3"]`);
          if (threeRadio && !threeRadio.checked) {
            threeRadio.checked = true;
            updateTierState(instances.main, threeRadio);
          }
        }

        // Only Set-of-1 mini ladder uses dynamicFlow; do not force true for Set of 3 / 6 or autoSwitchTier will snap radios to 1
        if (isMini) {
          const checkedTier = instances.main.root?.querySelector(`${S.TIER_INPUT}:checked`);
          instances.main.dynamicFlow = Boolean(checkedTier && Number(checkedTier.value) === 1);
        } else {
          instances.main.dynamicFlow = false;
          instances.main.sixFromThreeUpgrade = false;
        }

        if (isMini) {
          selectDefaultShade();
          syncStickyMiniAtc(instances.main);
        } else {
          const stdForm = document.querySelector('.js-mbStandardView .js-productForm');
          stdForm?.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  }

  return { init, destroy };
})();
/**
 * Custom-element host for the Miracle Balm set builder.
 *
 * Thin wrapper around the existing `miracleBalmSetBuilder` module — the module
 * still owns all logic and document-wide queries; the element only provides a
 * deterministic init/teardown lifecycle in place of the previous
 * `DOMContentLoaded` + `shopify:section:load` IIFE. The module's `init()` is
 * idempotent and `destroy()` cleans up its event listeners and instances.
 */
class MiracleBalmSetBuilder extends HTMLElement {
  connectedCallback() {
    if (typeof miracleBalmSetBuilder?.init !== 'function') return;
    try {
      miracleBalmSetBuilder.init();
    } catch (e) {
      console.error('MB init error', e);
    }
  }

  disconnectedCallback() {
    if (typeof miracleBalmSetBuilder?.destroy !== 'function') return;
    try {
      miracleBalmSetBuilder.destroy();
    } catch {
      /* swallow — teardown should never block */
    }
  }
}

if (!customElements.get('miracle-balm-set-builder')) {
  customElements.define('miracle-balm-set-builder', MiracleBalmSetBuilder);
}
